import { render, staticRenderFns } from "./AttachmentsViewer.vue?vue&type=template&id=8f9729dc&scoped=true"
import script from "./AttachmentsViewer.vue?vue&type=script&lang=ts"
export * from "./AttachmentsViewer.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentsViewer.vue?vue&type=style&index=0&id=8f9729dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9729dc",
  null
  
)

export default component.exports